import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import '../styles/Mission.css';

const Mission = () => {
  useEffect(() => {
    AOS.init({ duration: 1200, once: true });
  }, []);

  return (
    <div className="mission-container">
      <div className="mission-row">
        <div className="mission-box mission-vision" data-aos="fade-right">
          <h2>MISSION</h2>
          <p>
            To be an implementer of current practices with high technical standards in power utility projects of varying capacities and diversified infrastructures.
          </p>
        </div>
        <div className="mission-box mission-values" data-aos="fade-left">
          <h2>VISION</h2>
          <p>
            To be an organization demonstrating the capability and commitment to meet customers’ requirements with best practices and efficiency, while maintaining safety with stringent measures.
          </p>
        </div>
      </div>

      <div className="mission-row full">
        <div className="mission-box mission-mission" data-aos="fade-up">
          <h2>MESSAGE FROM OUR MD</h2>
          <p>
            As we continue to innovate and push boundaries in the electrical industry, I want to emphasize our commitment to safety, sustainability, and customer satisfaction. Let's work together to deliver exceptional solutions that power progress and illuminate lives.
            <br /><br />
            <span>– PRABHU RAGHUNATHAN</span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Mission;
